import { leakList } from "@/mocks/kanliao";

export default function LeakGrid() {
  return (
    <section id="leaks" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex items-end justify-between">
          <div>
            <span className="font-label text-xs font-semibold uppercase tracking-[0.24em] text-primary-600">
              最新爆料合集
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              刚刚过去几小时，又有什么新瓜
            </h2>
          </div>
          <span className="hidden shrink-0 items-center gap-1.5 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-medium text-secondary-700 sm:inline-flex">
            <i className="ri-time-line text-sm" aria-hidden="true"></i>
            按发布时间排序 · 今日 36+
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {leakList.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200/80 transition-shadow hover:ring-primary-200"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={`看料网 ${item.title}`}
                  className="h-44 w-full object-cover object-center transition-transform duration-500 group-hover:scale-105 md:h-48"
                />
                <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2 py-0.5 text-[11px] font-semibold text-primary-700">
                  <i className="ri-eye-line text-xs" aria-hidden="true"></i>
                  {item.view}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-[15px] font-bold leading-snug text-foreground-950 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-secondary-700">{item.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-secondary-600">
                  <span className="flex items-center gap-1.5 font-medium text-foreground-800">
                    <i className="ri-at-line" aria-hidden="true"></i>
                    {item.source}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#feed"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            全网吃瓜汇总里还有更多
            <i className="ri-arrow-down-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}